export const DEFAULT_AVATAR = 'https://constell.com/img/avatar.jpg';

export const DEFAULT_IMG = `${import.meta.env.VITE_CDN_URL}/static/empty-image.svg`;
